import React, { memo, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaTrash } from "react-icons/fa";
import {
  getPrice,
  getOptimizedUrl,
} from "../../../../constants/globalFunction";
import { colors } from "../../../../constants/colors";
import { RUPEE } from "../../../../constants/globalConstants";
import "./CartProduct.css";

const CartProduct = ({
  item,
  onIncreaseQty,
  onDecreaseQty,
  selectedItem,
  onPressQty,
}) => {
  const navigate = useNavigate();
  const { image, size } = item;
  const [price, setPrice] = useState(0);
  const [amount, setAmount] = useState(0);
  const [quantity, setQuantity] = useState(item?.quantity);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setAmount(price * quantity);
  }, [price, quantity]);

  useEffect(() => {
    if (item) {
      setQuantity(item?.qty);
      const fetchPrice = async () => {
        const p = await getPrice(item?.size);
        setPrice(p || 0);
      };
      fetchPrice();
    }
  }, [item]);

  useEffect(() => {
    setLoading(false);
  }, [selectedItem, item]);

  const onIncrease = () => {
    onIncreaseQty(item);
  };

  const onDecrease = () => {
    onDecreaseQty(item, false);
  };

  const onDelete = () => {
    onDecreaseQty(item, true);
  };

  const handleOnPressQty = () => {
    onPressQty(item);
  };

  const onPressProduct = () => {
    const productUrl = `/product?product_id=${item?._id}`;
    window.open(productUrl, "_blank");
  };

  return (
    <div className="cart-product" onClick={onPressProduct}>
      <div className="cart-product-row">
        <img
          src={getOptimizedUrl(image?.image)}
          alt={item?.name}
          className="cart-product-image"
          loading="lazy"
        />
        <div className="cart-product-details">
          <h3 className="cart-product-name" title={item?.name}>
            {item?.name}
          </h3>
          <p className="cart-product-detail">Size: {size?.size}</p>
          <p className="cart-product-detail">{item?.color?.name}</p>
          <div className="cart-product-price-row">
            <span className="cart-product-price">
              {RUPEE}
              {price}
            </span>
            {!item?.is_update ? (
              <div className="cart-quantity-box">
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    onDecrease();
                  }}
                  className="cart-qty-btn"
                  disabled={loading}
                >
                  −
                </button>
                {loading ? (
                  <div className="cart-loading">Loading...</div>
                ) : (
                  <span
                    className="cart-qty-text"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleOnPressQty();
                    }}
                  >
                    {quantity}
                  </span>
                )}
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    onIncrease();
                  }}
                  className="cart-qty-btn"
                  disabled={loading}
                >
                  +
                </button>
              </div>
            ) : (
              <span className="cart-unavailable-text">
                Currently Unavailable
              </span>
            )}
          </div>
        </div>
      </div>

      <div className="cart-product-separator" />
      <div className="cart-product-amount-container">
        <button
          onClick={(e) => {
            e.stopPropagation();
            onDelete();
          }}
          className="cart-delete-btn"
        >
          <FaTrash size={16} color={colors.red} />
        </button>
        <span className="cart-amount-text">
          Amount : {RUPEE}
          {amount}
        </span>
      </div>
    </div>
  );
};

export default memo(CartProduct);
